(function () {
  const dialog = document.querySelector('[data-ga-size-guide]');
  if (!dialog) return;

  const toolbar = dialog.querySelector('[data-ga-size-guide-toolbar]');

  /** @param {string} range */
  function cmRangeToInches(range) {
    return range
      .split('–')
      .map((part) => part.trim())
      .map((value) => Math.round((Number(value) / 2.54) * 10) / 10)
      .join(' – ');
  }

  /** @param {string} value */
  function cmValueToDisplay(value, unit) {
    if (!value) return '';
    if (value.includes('–')) {
      return unit === 'in' ? cmRangeToInches(value) : value;
    }
    const number = Number(value);
    if (Number.isNaN(number)) return value;
    return unit === 'in' ? String(Math.round((number / 2.54) * 10) / 10) : value;
  }

  /** @param {'cm' | 'in'} unit */
  function setUnit(unit) {
    dialog.querySelectorAll('[data-ga-size-guide-unit]').forEach((button) => {
      button.classList.toggle('is-active', button.getAttribute('data-ga-size-guide-unit') === unit);
    });

    dialog.querySelectorAll('[data-ga-size-guide-table] tbody tr').forEach((row) => {
      row.querySelectorAll('[data-measure]').forEach((cell) => {
        const measure = cell.getAttribute('data-measure');
        if (!measure) return;
        const cmValue = row.getAttribute(`data-${measure}-cm`);
        if (!cmValue) return;
        cell.textContent = cmValueToDisplay(cmValue, unit);
      });
    });

    dialog.querySelectorAll('[data-ga-size-guide-length-row]').forEach((row) => {
      const cmValue = row.getAttribute('data-height-cm');
      const cell = row.querySelector('[data-measure="height"]');
      if (!cell || !cmValue) return;
      cell.textContent = cmValueToDisplay(cmValue, unit);
    });
  }

  /** @param {'fit' | 'measure' | 'find-fit'} tab */
  function setTab(tab) {
    dialog.setAttribute('data-active-panel', tab);
    toolbar?.classList.toggle('is-hidden', tab !== 'fit');

    dialog.querySelectorAll('[data-ga-size-guide-tab]').forEach((button) => {
      const isActive = button.getAttribute('data-ga-size-guide-tab') === tab;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    dialog.querySelectorAll('[data-ga-size-guide-panel]').forEach((panel) => {
      const isActive = panel.getAttribute('data-ga-size-guide-panel') === tab;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });
  }

  function openDialog() {
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    }
    setTab('fit');
    setUnit('cm');
  }

  function closeDialog() {
    if (dialog.open) dialog.close();
  }

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    if (target.closest('[data-ga-size-guide-open]')) {
      event.preventDefault();
      openDialog();
      return;
    }

    if (target.closest('[data-ga-size-guide-close]')) {
      event.preventDefault();
      closeDialog();
      return;
    }

    const gotoButton = target.closest('[data-ga-size-guide-goto]');
    if (gotoButton instanceof HTMLElement && dialog.contains(gotoButton)) {
      event.preventDefault();
      const tab = gotoButton.getAttribute('data-ga-size-guide-goto');
      if (tab === 'fit' || tab === 'measure' || tab === 'find-fit') setTab(tab);
      return;
    }

    const unitButton = target.closest('[data-ga-size-guide-unit]');
    if (unitButton instanceof HTMLButtonElement && dialog.contains(unitButton)) {
      const unit = unitButton.getAttribute('data-ga-size-guide-unit');
      if (unit === 'cm' || unit === 'in') setUnit(unit);
      return;
    }

    const tabButton = target.closest('[data-ga-size-guide-tab]');
    if (tabButton instanceof HTMLButtonElement && dialog.contains(tabButton)) {
      const tab = tabButton.getAttribute('data-ga-size-guide-tab');
      if (tab === 'fit' || tab === 'measure' || tab === 'find-fit') setTab(tab);
    }
  });

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) closeDialog();
  });

  dialog.addEventListener('cancel', (event) => {
    event.preventDefault();
    closeDialog();
  });
})();
